import { MessageCircle } from "lucide-react";
import { CONTACT } from "@/lib/data";

export default function WhatsAppButton() {
  const msg = encodeURIComponent("Hi SKVY Harmony team! I'd like to discuss US IT job opportunities / career consultation.");
  return (
    <a
      href={`https://wa.me/${CONTACT.whatsapp}?text=${msg}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full flex items-center justify-center shadow-2xl transition-transform hover:scale-110"
      style={{ background: "#25D366", boxShadow: "0 12px 40px -8px rgba(37,211,102,0.6)" }}
    >
      <MessageCircle className="w-6 h-6 text-white" fill="white" strokeWidth={0} />
      <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-30 animate-ping" />
    </a>
  );
}
